var Payment = xClass("TTlightgamePayment")
Payment.prototype.ctor = function () {

}

Payment.prototype.errCodeToMsg = function (errCode) {
    var msg = "支付失败";
    switch(errCode) {
        case -1:
            msg = "支付失败";
            break;
        case -2:
            msg = "支付取消";
            break;
        case -15001:
            msg = "缺少参数";
            break;
        case -15002:
            msg = "请求参数不合法";
            break;
        case -15006:
            msg = "app 没有支付权限";
            break;
        case -15009:
            msg = "财经方失败";
            break;
        case -15098:
            msg = "当前用户未通过实名认证";
            break;
        case -15099:
            msg = "当前用户累计支付金额超过限制";
            break;
        case -16000:
            msg = "户未登录";
            break;
        case 2:
            msg = "正在支付一起订单时，又发起了一笔支付请求";
            break;
        case 3:
            msg = "调起收银台失败";
            break;
        case 4:
            msg = "网络异常";
            break;
        case 6:
            msg = "其他错误";
            break;
   }
    return msg;
}
// 获取失败类型
Payment.prototype.getFailType = function (errCode) {
    let fail_type = 1;
    if (errCode == -2){
        fail_type = -1;
    }
    return fail_type;
}

Payment.prototype.buy = function (data, successCallback, failCallback, closeCallback) {
    let self = this

    console.warn("[tt] call tt pay id:"+data.productId)
    let productId = data.productId
    let hasPayResult = false
    self.dcSession = data.dcSession
    self.dcScence = data.dcScence
    self.dcGoodsId = data.dcGoodsId

    // if (__DEBUG){
    //     console.log("[tt] debug queryOrder id")
    //     this.queryOrder("ec38c885eb54f2132b30ac748f7111502177c083", successCallback, failCallback)
    //     return
    // }

    function onSuccess(resp) {
        let data = resp.data
        if (data.ext){
            data.ext.buyQuantity = data.price*10
        }else{
            data.ext = {
                buyQuantity : data.price*10
            }
        }
        self.dcPrice = data.price
        console.log("[tt] getinfohttp success data", data)
        let orderId = data.orderId;
        DCAssist.dc4TTIosCreateOrder(self.dcSession, self.dcScence, self.dcGoodsId, orderId) 
        let balance = data.balance
        let cash = data.cash
        let payment = {
            mode: "game",
            env:0,
            currencyType: "CNY",
            platform: "android",
            buyQuantity: data.price*10,
            zoneId: "1",
            customId: data.orderId,
            extraInfo: "",
            success: function(){
                console.log("[tt] pay success")
                hasPayResult = true
                if (mini.getSystemInfoSync().platform == "ios"){
                    self.queryOrder(orderId, successCallback, failCallback)
                }else{
                    if (successCallback)
                        successCallback({orderId})
                }
            },
            fail: function (res) {
                console.log("[tt] pay fail", res)
                hasPayResult = true
                let fail_type = self.getFailType(res.errCode);
                failCallback({
                    code: res.errCode,
                    data: self.errCodeToMsg(res.errCode),
                    msg: self.errCodeToMsg(res.errCode),
                    type: fail_type,//1代表是第三方掉起支付失败
                })
                DCAssist.dc4IosGotoBuyCashGoodsFail(self.dcSession, self.dcScence, self.dcGoodsId, "1", self.dcEntry)
            },
            complete:function(){
                if (!hasPayResult){
                    console.log("[tt] pay complete not hasPayResult")
                }
            }
        }
        console.log("[tt] pay data ", payment)
        console.log("[tt] pay sys info", mini.getSystemInfoSync())
        mini.requestMidasPayment(payment)
    }

    function onFail(evt) {
        cc.log("[tt] getinfohttp failed" + evt.data)
        let errcode = evt ? evt.data : -1;
        failCallback({
            code: errcode,
            data: "初始化订单失败"
        })
    }

    function onCancel() {
        console.log("[tt] getinfohttp canecel")
        failCallback({
            code: -1,
            data: "初始化订单取消"
        })
    }


    // 抖音登陆过账号后退出进行游客登陆，重新登陆游戏checkSession仍然返回success，因此需要通过登陆时的标志位判断是否为游客登陆/端登陆
    // 测试版本：App 11.5.0 - Android @2020/06/28
    let getinfohttp = ()=>{
        let http = TTlightgamePaymentGetInfoHttp.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onCancel)
        http.load({
            productId:productId,
            openid: META.tokenid,
            zoneId: META.user.serverid,
            sessionid: META.user.sessionid,
            serverId: META.user.serverid,
            ext: data.ext

        })
    }
    if (mini.isPlatformLogin()) {
        mini.checkSession({
            success:function(){
                getinfohttp();
            },
            fail(){
                // failCallback({
                //     code: -1,
                //     data: getText("douyin_guest_pay_tip")
                // })
                console.log("[tt] checkSession fail tt openid",META.tokenid)
                console.log("[tt] checkSession fail tt sessionid",META.user.sessionid)
                // Toast.make(getText("sessionid:"+META.user.sessionid));

                mini.login({
                    force: false,
                    success: res=> {
                        console.log("[tt] checkSession fail tt login res",res)
                        getinfohttp();
                    },
                    complete:function(){
                        console.log("[tt] retry login complete");
                    },
                    fail:function(res){
                        console.log("[tt] retry login failed", res.errMsg);      
                        failCallback({
                            code: -1,
                            data: getText("douyin_guest_pay_tip")
                        })     
                    }
                });

                // require("clover/sns/SnsProxy").getInstance().showDialog({
                //     text: getText("error.tip.761962"),
                //     needOkBtn: true,
                //     okBtnText: getText("bank_refreshInfo_btn"),
                // }, () => {
   
                // })
            },
            complete: res=> {
                console.log("[tt] pay checkSession complete.", res)
            }
        })
    } else {
        failCallback({
            code: -1,
            data: getText("douyin_guest_pay_tip")
        })
    }
}

Payment.prototype.queryOrder = function(orderId, successCallback, failCallback){
    let self = this
    
    let loadId = LoadingPanelLogic.getInstance().add("购买中，请耐心等待...", () => {
        LoadingPanelLogic.getInstance().remove(loadId)
    })
    let pf = global.mini ? mini.getPlatform() : "";
    let realOrderId = pf + orderId;

    var http = QueryOrderStateHttp.new();
    let retryMax = 5; //重试上限 
    let retryNum = 0;
    let retryInterval = 1; //重试间隔
    let retryFunc = () => {
        retryNum++;
        if (retryNum > retryMax) {
            LoadingPanelLogic.getInstance().remove(loadId)
            DCAssist.dc4TTIosPayFail(self.dcSession, self.dcGoodsId, orderId, "2")
            if (failCallback){
                failCallback({
                    code: -1,
                    data: "douyin_game iOS payment check fail",
                    msg: "订单查询失败",
                    type: 2,
                })
            }
            return;
        }
        setTimeOut(() => {
            console.log("[tt] 重试检查订单状态");
            http.load(realOrderId);
        }, retryInterval)
    }
    let onSuccess = (evt) => {
        console.log("[tt] checkOrderState evt ", evt);
        if (evt.data.success && evt.data.finished) {
            DCAssist.dc4TTIosPayFinish(self.dcSession, self.dcScence, self.dcGoodsId, orderId, self.dcPrice)
            LoadingPanelLogic.getInstance().remove(loadId)
            if (successCallback){
                successCallback({orderId})
            }
        } else {
            retryFunc();
        }
    }
    let onFail = () => {
        retryFunc();
    }

    http.addEventListener(Events.kComplete, onSuccess);
    http.addEventListener(Events.kError, onFail);
    http.addEventListener(Events.kCancel, onFail);

    http.load(realOrderId);
}

module.exports = Payment